import React, {FC} from "react"

import GenericModal from "@irati/ui/src/GenericModal"

import EnableSSO from "../EnableSSO"

interface Props {
  show: boolean
  onHide: () => void
}

const SetupStep: FC<Props> = ({show, onHide}) => {
  return (
    <GenericModal hideActions show={show} onHide={onHide}>
      <EnableSSO onClose={onHide} />
    </GenericModal>
  )
}

export default SetupStep
